<template>
    <div class="container-render-post" :style="{ fontSize: fontSize + 'px' }" ref="render-post">
        <div class="render-reel-facebook">
            <div class="header-app">
                Reels
            </div>
            <div class="reel-content" @click="clickOnPost">
                <video 
                v-if="medias.length" 
                v-for="(media, index) in medias.filter(m => m.type.startsWith('video/')).slice(0,1)" 
                :class="{'cover': media.info.aspectRatio <= 0.5625}"
                :autoplay="true"
                :muted="videoMuted"
                loop
                playsinline
                crossorigin="anonymous"
                preload="metadata"
                :src="media.url"
                :type="media.type" 
                :key="index"></video>

                <div class="nav-lateral">
                    <div class="like">
                      
                    </div>
                    <div class="comment">
                       
                    </div>
                    <div class="send">
                       
                    </div>

                    <div class="more">
                        <i class="fa-solid fa-ellipsis"></i>
                    </div>
                    
                </div>
                <div class="info-reel">
                    <div class="page">
                        <div class="images" :class="{multiple : pages.length > 1}">
                            <img
                                v-for="(page, index) in visiblePages"
                                @click="() => onClickAvatar(page, index)"
                                :src="page.avatar"
                                :key="index"
                            >
                            <ContextMenu
                                v-if="pages.length > 3"
                                :options="hiddenPagesOptions"
                                id="contextMenuHiddenPagesReelFacebook"
                                v-on:clickOption="(_, pageId) => $emit('featurePage', pageId)"
                            >
                                <div class="count">
                                    +{{ pages.length - 3 }}
                                </div>
                            </ContextMenu>
                        </div>
                        <div class="names">
                            <p class="page-name" v-if="featuredPage" @click="openFacebookPage(featuredPage)">{{ featuredPage.name }}</p>
                            <p class="music-name" v-if="musicName"><i class="fa-solid fa-music"></i>{{ musicName }}</p>
                        </div>
                    </div>
                    <div 
                    class="description-reel" 
                        v-if="description" 
                        :class="{'cut-content': !fullContent}" 
                        @click.stop="toggleFullContent" 
                        v-html="textTranslateMentionAndHastag">
                    </div>
                </div>

                <div :key="videoMuted ? 'no-sound' : 'sound'" :class="videoMuted ? 'no-sound' : 'sound'"></div>
            </div>
        </div>

        <SelectPerson v-if="modes.includes('addIdentifierMode')"
            :personsSelect="personsIdentified"
            :positionClick="paramsContentOverflow.identify.positionClick"
            :position="positionFormOverlay"
            @close="closeContentOverflow"
            @resetPositionClick="resetClick"
            
        />
        <SelectPerson v-if="modes.includes('addCollaboratorMode')"
            :personsSelect="collaborators"
            :positionClick="paramsContentOverflow.identify.positionClick"
            :position="positionFormOverlay"
            @close="closeContentOverflow"
            @resetPositionClick="resetClick"
        />
    
        <SelectPlace v-if="modes.includes('addPlaceMode')" 
            @close="closeContentOverflow"
            :placeSelected="place"
            :position="positionFormOverlay"
            :network="'facebook'"
        />
        <SelectMusic v-if="modes.includes('addMusicMode')" 
            @close="closeContentOverflow" 
            :musicSelected="music"
            :position="positionFormOverlay"
        />
    </div>
  
</template>

<script>
    import { EventBus } from '@/event-bus';
    import { Carousel, Slide } from 'vue-carousel';
    import SelectMusic from '../../formOverlay/selectMusic.vue';
    import SelectPlace from '../../formOverlay/selectPlace.vue';
    import SelectPerson from '../../formOverlay/selectPerson.vue';
    import ContextMenu from '@/components/dash/contextMenu/contextMenuInit.vue'
    import renderPostMixin from '../../../mixins/renderPost';

    export default {
        mixins: [renderPostMixin],
        components: {
            Carousel,
            Slide,
            SelectMusic,
            SelectPlace,
            SelectPerson,
            ContextMenu
        },

        props: {
            pages: {
                type: Array,
                default: ()=>[] 
            },
            musicName : {
                type: String,
                default: ''
            },

            description : {
                type: String,
                default: ''
            },
            medias: {
                type: Array,
                default: ()=>[] 
            },

            personsIdentified: {
                type: Array,
                default: ()=>[] 
            },
            collaborators: {
                type: Array,
                default: ()=>[] 
            },
            place: {
                type: Object,
                default: undefined
            },
            music: {
                type: Object,
                default: undefined
            },
            modes: {
                type: Array,
                default: ()=>[] 
            },
            mentions : {
                type: Object,
                default: ()=>({})
            },
            positionFormOverlay: {
                type: String,
                default: 'left'
            },
            

        },

        data() {
            return {
                paramsContentOverflow : {
                    identify : {
                        positionClick : undefined,
                        lastMouseDownEvent: {}
                    },
                },
                videoMuted: true,
                fullContent: false,
            }
        },

        methods: {

            clickOnPost(e) {
                console.log("clickOnPost")
                if (this.fullContent) {
                    this.fullContent = false;
                    return;
                }
                this.paramsContentOverflow.identify.positionClick = {
                    x : 50,
                    y : 50,
                    idFile : this.medias.filter(m => m.type.startsWith('video/'))[0].id
                }
                this.videoMuted = !this.videoMuted
            },

            toggleFullContent() {
                this.fullContent = !this.fullContent;
            },

            resetClick() {
                this.paramsContentOverflow.identify.positionClick = undefined
            },

            closeContentOverflow() {
                EventBus.$emit('postCreatorRemoveMode', 'all')
                this.resetClick()
            },

            openFacebookPage(page) {
                const url = `https://www.facebook.com/${page.network_id}/`;
                window.open(url, '_blank');
            },

            onClickAvatar(page, index) {
                const isTop = index === this.visiblePages.length - 1
                if (!isTop) {
                    this.$emit('featurePage', page.id)
                    return
                }
                page.iconEdited ? this.$emit('clickPage', page.id) : this.openFacebookPage(page)
            }
        },
        computed: {
            visiblePages() {
                return this.pages.slice(0, 3)
            },

            featuredPage() {
                return this.visiblePages.length ? this.visiblePages[this.visiblePages.length - 1] : null
            },

            hiddenPagesOptions() {
                return this.pages.slice(this.visiblePages.length).map(page => ({ label: page.name, name: page.id }))
            },

            textTranslateMentionAndHastag() {
                //return this.text
                let mentionCount = 0;
                return this.description.substring(0,2200).replace(/#[\wÀ-ÿ]+/g, '<b class="hashtag">$&</b>').replace(/@(\d{13})/g, (match, id) => {

                    const mention = this.mentions[id];
                    if (mention) {
                        if (mentionCount < 20 && mention.mention && mention.mention.facebook) {
                            mentionCount++
                            return `<span class="mention">${mention.mention.facebook.name || mention.mention.facebook.id}</span>`
                        }else{
                            return mention.textDefault
                        }
                    }
                    return match;
                }).replace(/\n/g, '<br>');
              
            },
        },
    }
</script>
